export const changeStyleSheetUrl = (id: string, value: string, from: number) => {
  const element = document.getElementById(id)
  const urlTokens = element?.getAttribute("href")?.split("/") || []

  if (from === 1) {
    // which function invoked this function
    urlTokens[urlTokens.length - 1] = value
  } else if (from === 2) {
    // which function invoked this function
    if (value !== null) {
      urlTokens[urlTokens.length - 2] = value
    }
  } else if (from === 3) {
    // which function invoked this function
    urlTokens[urlTokens.length - 2] = value
  }

  const newURL = urlTokens.join("/")
  // Already on that sheet (index.html links the initial theme): swapping would
  // re-insert the same stylesheet for nothing.
  if (element?.getAttribute("href") === newURL) return

  if (element instanceof HTMLLinkElement) {
    replaceLink(element, newURL)
  }
}

const replaceLink = (linkElement: HTMLLinkElement, href: string) => {
  if (isIE()) {
    linkElement.setAttribute("href", href)
  } else {
    const id = linkElement.getAttribute("id") || ""
    const cloneLinkElement = linkElement.cloneNode(true) as HTMLLinkElement

    cloneLinkElement.setAttribute("href", href)
    cloneLinkElement.setAttribute("id", `${id}-clone`)

    linkElement.parentNode?.insertBefore(cloneLinkElement, linkElement.nextSibling)

    cloneLinkElement.addEventListener("load", () => {
      linkElement.remove()
      cloneLinkElement.setAttribute("id", id)
    })
  }
}

const isIE = () => {
  return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
}
